import { Tile, Stat, Row, TileLink } from "./Tile";

const OUTCOMES = [["open", "Open"], ["cleared", "Cleared"], ["replaced", "Replaced"], ["overridden", "Let through"], ["abandoned", "Abandoned"]];

export const HeldTile = ({ held, tone, index }) => (
  <Tile id="held" index={index} tone={tone} kicker="View check" title="Held ducks"
    action={<TileLink to="/admin/held" testid="held-open-page">Open held ducks</TileLink>}>
    <div className="grid grid-cols-2 gap-2">
      <Stat testid="held-now" label="Held now" value={held.held_now} tone={held.held_now ? "red" : undefined} />
      <Stat testid="held-review" label="Waiting for review" value={held.waiting_for_review} tone={held.waiting_for_review ? "amber" : undefined} />
    </div>
    <div className="mt-2 min-h-0 flex-1 overflow-y-auto pr-1">
      {OUTCOMES.map(([key, label]) => <Row key={key} label={`Block log · ${label}`} testid={`held-log-${key}`} value={held.counts?.[key] ?? 0} />)}
    </div>
  </Tile>
);
